import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

/**
 * The official multicolor Slack mark. The brand colors are fixed, so the shared `fill`/`stroke`
 * props don't apply here — only sizing/className/style are honored.
 */
export function SlackIcon({ className, height, style, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height ?? 24}
      style={style}
      viewBoxDimensions="0 0 127 127"
      width={width ?? 24}
    >
      <path
        d="M27.2 80c0 7.3-5.9 13.2-13.2 13.2C6.7 93.2.8 87.3.8 80c0-7.3 5.9-13.2 13.2-13.2h13.2V80z"
        fill="#E01E5A"
      />
      <path
        d="M33.8 80c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2v33c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V80z"
        fill="#E01E5A"
      />
      <path
        d="M47 27.2c-7.3 0-13.2-5.9-13.2-13.2C33.8 6.7 39.7.8 47 .8c7.3 0 13.2 5.9 13.2 13.2v13.2H47z"
        fill="#36C5F0"
      />
      <path
        d="M47 33.8c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H14c-7.3 0-13.2-5.9-13.2-13.2C.8 39.7 6.7 33.8 14 33.8h33z"
        fill="#36C5F0"
      />
      <path
        d="M99.8 47c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H99.8V47z"
        fill="#2EB67D"
      />
      <path
        d="M93.2 47c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V14C66.8 6.7 72.7.8 80 .8c7.3 0 13.2 5.9 13.2 13.2v33z"
        fill="#2EB67D"
      />
      <path
        d="M80 99.8c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V99.8H80z"
        fill="#ECB22E"
      />
      <path
        d="M80 93.2c-7.3 0-13.2-5.9-13.2-13.2 0-7.3 5.9-13.2 13.2-13.2h33c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H80z"
        fill="#ECB22E"
      />
    </SimpleIcon>
  );
}
